import React from "react";

// A dual-handle range slider built from two overlapping native <input type="range"> elements -
// deliberately no new npm dependency for this (several exist, e.g. rc-slider, but a two-input
// range slider is a well-established, ~40-line pattern that doesn't warrant pulling in a whole
// library + its own CSS just for "advanced filters" sliders on the search box). Each thumb is a
// real native range input stacked on the same track, so keyboard/touch/accessibility all come for
// free from the browser rather than being reimplemented.
//
// `value` is [min, max]; `onChange` receives the new [min, max] pair. The two thumbs are kept from
// crossing (min can't exceed max and vice versa) so the range never inverts into a confusing
// "min > max" state.
export default function RangeSlider({min, max, step = 1, value, onChange, formatValue = (v) => v, label}) {
  const [lo, hi] = value;

  const handleLoChange = (e) => {
    const next = Math.min(Number(e.target.value), hi);
    onChange([next, hi]);
  };
  const handleHiChange = (e) => {
    const next = Math.max(Number(e.target.value), lo);
    onChange([lo, next]);
  };

  const pctLo = ((lo - min) / (max - min)) * 100;
  const pctHi = ((hi - min) / (max - min)) * 100;

  return (
      <div className="rangeSlider">
        {label && (
            <div className="d-flex justify-between items-center mb-10">
              <div className="text-14 fw-500">{label}</div>
              <div className="text-13 text-light-1">{formatValue(lo)} &ndash; {formatValue(hi)}</div>
            </div>
        )}
        <div className="rangeSlider__track">
          <div className="rangeSlider__fill" style={{left: pctLo + "%", width: (pctHi - pctLo) + "%"}}/>
          <input
              type="range" min={min} max={max} step={step} value={lo}
              onChange={handleLoChange}
              className="rangeSlider__input"
              aria-label={label ? `${label} - minimum` : "minimum"}
          />
          <input
              type="range" min={min} max={max} step={step} value={hi}
              onChange={handleHiChange}
              className="rangeSlider__input"
              aria-label={label ? `${label} - maksimum` : "maksimum"}
          />
        </div>
      </div>
  );
}
